<template>
  <div>
    <transition name="top-slide">
      <div class="picker" v-if="show">
        <div class="picker-main">
          <p class="picker-res">{{categoryRes | resTxt}}</p>
          <div class="picker-select">
            <div class="select-list">
              <ul>
                <li @click="selectCgy1(-1)"><span :class="{ active : cgy1 === -1 }">全部</span></li>
                <li
                  v-for="(item, index) in categorys"
                  :key="index"
                  @click="selectCgy1(index)"
                ><span :class="{ active : cgy1 === index }">{{item.title}}</span></li>
              </ul>
            </div>
            <div class="select-list">
              <ul>
                <li @click="selectCgy2(-1)"><span :class="{ active : cgy2 === -1 }">全部</span></li>
                <li
                  v-for="(item, index) in categorys2"
                  :key="index"
                  @click="selectCgy2(index)"
                ><span :class="{ active : cgy2 === index }">{{item.title}}</span></li>
              </ul>
            </div>
            <div class="select-list">
              <ul>
                <li @click="selectCgy3(-1)"><span :class="{ active : cgy3 === -1 }">全部</span></li>
                <li
                  v-for="(item, index) in categorys3"
                  :key="index"
                  @click="selectCgy3(index)"
                ><span :class="{ active : cgy3 === index }">{{item}}</span></li>
              </ul>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="picker-btns">
            <div class="btn-close" @click="$emit('hidePicker')">取消</div>
            <div class="btn-enter" @click="submit">确认</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import categorys from './category.js';
export default {
  props: {
    show: Boolean
  },
  data() {
    return {
      categorys: categorys,
      cgy1: -1,
      cgy2: -1,
      cgy3: -1
    }
  },
  computed: {
    categoryRes() {
      let res = "";
      if (this.cgytt1) {
        res = this.cgytt1;
        if (this.cgytt2) {
          res += "-" + this.cgytt2;
          if (this.cgytt3) {
            res += "-" + this.cgytt3;
          }
        }
      };
      return res;
    },
    categorys2() {
      if (this.cgy1 != -1) {
        return this.categorys[this.cgy1].submenu;
      }
    },
    categorys3() {
      if (this.cgy1 != -1 && this.cgy2 != -1) {
        const cgy = this.categorys2[this.cgy2];
        return cgy.submenu ? cgy.submenu : [];
      }
    },
    cgytt1() {
      if (this.cgy1 != -1) {
        return this.categorys[this.cgy1].title;
      }
      return "";
    },
    cgytt2() {
      if (this.cgy2 != -1) {
        return this.categorys2[this.cgy2].title;
      }
      return "";
    },
    cgytt3() {
      if (this.cgy2 != -1 && this.cgy3 != -1) {
        return this.categorys3[this.cgy3];
      }
      return "";
    }
  },
  filters: {
    resTxt(value) {
      return value ? value : "全部"
    }
  },
  methods: {
    selectCgy1(index) {
      this.cgy1 = index;
      this.cgy2 = -1;
      this.cgy3 = -1;
    },
    selectCgy2(index) {
      this.cgy2 = index;
      this.cgy3 = -1;
    },
    selectCgy3(index) {
      this.cgy3 = index;
    },
    submit() {
      this.$emit('submit', this.categoryRes);
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/base";
.picker {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 0.875rem;
  background-color: rgba(0, 0, 0, .4);

  .picker-main {
    width: 100%;
    padding: 4rem 1rem 1rem;
    background-color: $text-dark;
  }

  .picker-res {
    color: $primary;
    font-size: 16px;
    font-weight: 700;
  }

  .picker-select {
    display: flex;

    .select-list {
      flex: 1;
      height: 16rem;
      overflow-y: auto;
      margin: 0 0.5rem;

      ul {
        margin: 0;
      }

      li {
        padding: 0.5rem 0;

        span {
          padding: 0.25rem 0.5rem;
          border-radius: 2px;

          &.active {
            background-color: $primary;
            color: $text-dark;
          }
        }
      }
    }
  }

  .picker-btns {
    display: flex;
    justify-content: space-around;
    margin-top: 1rem;
    text-align: center;

    div {
      width: 35%;
      padding: 0.35rem 1rem;
      border-radius: 3px;
      box-sizing: border-box;
    }

    .btn-close {
      border: 0.5px solid $primary;
      color: $primary;
      opacity: 0.75;
    }

    .btn-enter {
      background-color: $primary;
      color: $text-dark;
    }
  }
}
</style>
